import React, { useEffect, useState } from 'react'
import Banner from './Banner'
import './About.css'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'

import SendIcon from '@mui/icons-material/Send';

const TermsCondition = ({ galleryRef, contactRef }) => {
    const pageName = "Terms & Conditions"

    return (
        <>
            <Banner pageName={pageName} />
            <section className='abt_cont'>
                <div className='container'>
                    <article>
                        <div className='d-flex mb-6 mt-3 flex-column align-items-end'>
                            <p className="text-muted mb-1">Effective Date: 8 August 2026</p>
                            <p className="text-muted">Last Updated: 8 August 2026</p>
                        </div>

                        <h1 className="text-center mb-5 uppercase fw-bold w-100 mt-4" style={{ color: "#5e79bc", lineHeight: "65px", textTransform: "uppercase", fontSize: "32px" }}>
                            Welcome to Car Genie, a brand operated by BM Enterprises <br /> ("BM Enterprises", "we", "us", or "our").
                        </h1>

                        <h3 className="mb-5" style={{ color: "#6d6c6c", lineHeight: "50px", fontWeight: 300 }}>
                            These Terms & Conditions govern your use of the Car Genie website and the purchase or use of services provided by Car Genie
                        </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            By accessing our website, submitting an enquiry, booking a service or availing any service from Car Genie, you agree to these Terms & Conditions.
                        </p>

                        <h3 style={{ color: "#5e79bc" }}> <span>1.</span> Services </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            Car Genie provides automotive services including, but not limited to:
                        </p>

                        <ul style={{ color: "#4b4a4a", lineHeight: "40px", fontSize: "18px" }} className='mb-3 w-100'>
                            <li>•⁠  Periodic and general vehicle servicing</li>
                            <li>•⁠  Mechanical repairs</li>
                            <li>•⁠  Electrical and diagnostic services</li>
                            <li>•⁠  Denting and painting</li>
                            <li>•⁠  Car detailing and polishing</li>
                            <li>•⁠  Ceramic coating</li>
                            <li>•⁠  Paint Protection Film (PPF)</li>
                            <li>•⁠  ⁠Insurance claim assistance</li>
                            <li>•⁠  Other automotive repair, maintenance and restoration services</li>
                        </ul>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>
                            The availability of individual services may vary depending on the vehicle and service location.
                        </p>

                        <h3 className='mt-5 w-100' style={{ color: "#5e79bc" }}> <span>2.</span> Vehicle Inspection and Diagnosis </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>A vehicle may require physical inspection before Car Genie can confirm the scope of work, parts required, estimated cost and expected completion time. </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>
                            Initial information provided through telephone, WhatsApp, social media or the website may not constitute a final diagnosis.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>
                            Additional defects may be identified after dismantling or during the repair process.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>
                            Where additional work is required, Car Genie may seek customer approval before proceeding, where reasonably practicable.
                        </p>

                        <h3 style={{ color: "#5e79bc" }}> <span>3.</span> Estimates and Quotations </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            Any estimate provided before inspection is indicative unless specifically identified as a confirmed quotation.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            The final invoice may differ from an initial estimate where additional repairs, parts, materials, labour or services become necessary.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            Taxes and other applicable charges may be added as required.
                        </p>


                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>4.</span> Customer Approval </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Where reasonably practicable, Car Genie will obtain customer approval before carrying out additional work that materially changes the originally estimated scope or cost</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Approval may be provided through written communication, electronic communication, WhatsApp, email or other recorded communication.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>5.</span> Parts and Materials </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Parts used for repairs may be:</p>

                        <ul style={{ color: "#4b4a4a", lineHeight: "40px", fontSize: "18px" }} className='mb-5 w-100'>
                            <li>•⁠  Genuine/OEM parts</li>
                            <li>•⁠  Original-equipment equivalent parts</li>
                            <li>•⁠  Aftermarket parts</li>
                            <li>•⁠  ⁠Reconditioned or used parts</li>
                        </ul>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>The type of part to be used will depend on the customer's requirement, availability, vehicle requirements and agreed quotation.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Where a customer specifically requests a particular type or brand of part, the customer may be responsible for ensuring that the selected part is suitable for the vehicle.</p>


                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>6.</span> ⁠Customer-Supplied Parts </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie may, at its discretion, accept parts supplied by customers.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie shall not be responsible for defects, incompatibility, premature failure or warranty issues arising solely from customer-supplied parts.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie may refuse to install a part if, in its reasonable opinion, the part is unsafe, unsuitable or incompatible with the vehicle.</p>


                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>7.</span> Vehicle Condition and Pre-Existing Defects </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Customers acknowledge that vehicles may have pre-existing damage, mechanical defects, electrical problems, accident history, modifications, wear and tear or other underlying issues.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie shall not be responsible for pre-existing conditions that were not caused by the services performed by Car Genie</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Certain repairs may reveal additional problems only after inspection, dismantling or commencement of work.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>8.</span> Vehicle Safety </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Where a vehicle is found to have a serious safety-related defect, Car Genie may recommend that the vehicle not be driven until the necessary repairs are completed</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}> The customer is responsible for deciding whether and how to move the vehicle where legally and reasonably permitted.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>9.</span> Service Completion and Delays </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Estimated completion times are indicative and may be affected by:</p>

                        <ul style={{ color: "#4b4a4a", lineHeight: "40px", fontSize: "18px" }} className='mb-5 w-100'>
                            <li>•⁠  Parts availability</li>
                            <li>•⁠  ⁠Supplier delays</li>
                            <li>•⁠   ⁠Insurance approvals</li>
                            <li>•⁠  ⁠Surveyor inspections</li>
                            <li>•⁠  ⁠Additional repairs</li>
                            <li>•⁠  ⁠Unforeseen technical issues</li>
                            <li>•⁠  ⁠Customer approvals</li>
                            <li>•⁠  ⁠Force majeure events</li>
                            <li>•⁠  ⁠Other circumstances beyond Car Genie's reasonable control</li>
                        </ul>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie will make reasonable efforts to keep customers informed of significant delays.</p>


                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>10.</span> ⁠Insurance Claims </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Where Car Genie provides insurance claim assistance, such assistance is limited to the services agreed with the customer.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>The insurance company and/or authorised surveyor independently determines claim approval, admissibility, depreciation, deductions and settlement.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie does not guarantee any particular insurance claim outcome.</p>


                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>11.</span> Payment </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Customers are required to pay the applicable amount stated on the final invoice or otherwise agreed with Car Genie.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Unless otherwise agreed, outstanding amounts must be settled before the vehicle is released.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie may require an advance payment for certain services, parts or special-order items.</p>


                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>12.</span> Vehicle Collection </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >Customers should collect their vehicle within the agreed or communicated timeframe after completion of the service.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            Where a vehicle remains at the workshop for an extended period after completion, Car Genie may communicate with the customer regarding collection and may apply reasonable charges where such charges have been disclosed or agreed.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>13.</span> Personal Belongings </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >Customers are advised to remove valuables and personal belongings from their vehicle before handing it over for service.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            Car Genie shall not be responsible for loss of personal belongings left inside the vehicle unless such loss is directly attributable to proven negligence or misconduct by Car Genie or its personnel.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>14.</span> Warranty </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >Where a warranty is provided for a particular service or part, the warranty period and conditions will be communicated through the relevant invoice, job card, quotation or warranty document.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            Warranty coverage may exclude normal wear and tear, accidental damage, misuse, modifications, customer-supplied parts, external damage or issues unrelated to the original service.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>15.</span> Cancellation and Refunds </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >Cancellations and refunds are governed by the Car Genie Refund & Cancellation Policy published on our website</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            Where work has commenced or parts/materials have been purchased specifically for a customer's vehicle, the customer may be liable for costs already incurred.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>16.</span> Website Use </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >Customers agree not to:</p>

                        <ul style={{ color: "#4b4a4a", lineHeight: "40px", fontSize: "18px" }} className='mb-5 w-100'>
                            <li>•⁠  ⁠Use the website for unlawful purposes </li>
                            <li>•⁠  ⁠Attempt to gain unauthorised access to our systems </li>
                            <li>•⁠  ⁠Upload malicious software or harmful material </li>
                            <li>•⁠  ⁠Misuse website forms or communication channels </li>
                            <li>•⁠  ⁠Copy or reproduce website content without permission </li>
                            <li>•⁠  ⁠Provide false or misleading information </li>
                        </ul>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>17.</span> ⁠Intellectual Property </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >The Car Genie name, logo, trademarks, photographs, graphics, text, designs, videos and other website content are owned by or licensed to BM Enterprises or their respective owners.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                           No website content may be reproduced, modified, distributed or commercially exploited without prior written permission, except where permitted by applicable law.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>18.</span> Third-Party Services </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >Certain services may involve third-party providers, including insurance companies, payment processors, parts suppliers, towing providers or other service partners.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                           Where applicable, the terms and conditions of those third parties may also apply.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>19.</span> Limitation of Liability </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >
                            To the extent permitted by applicable law, BM Enterprises shall not be liable for indirect, incidental, special or consequential losses arising from circumstances beyond its reasonable control.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            Nothing in these Terms & Conditions shall exclude or limit any liability that cannot legally be excluded or limited under applicable law.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>20.</span> Force Majeure </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >
                            Car Genie shall not be responsible for delays or inability to perform services caused by circumstances beyond its reasonable control, including natural disasters, fire, flood, strikes, governmental restrictions, supply-chain disruptions, accidents, civil disturbances, technological failures or other force majeure events.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>21.</span> Privacy </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >
                            The collection and use of customer information is governed by the Car Genie Privacy Policy published on our website.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>22.</span> Changes to Terms </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >
                            BM Enterprises may modify these Terms & Conditions from time to time.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            The updated version will be published on the Car Genie website with the revised "Last Updated" date.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>23.</span> Governing Law and Jurisdiction </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} >
                            These Terms & Conditions shall be governed by the laws of India.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-2'>
                            Subject to applicable law, disputes arising in connection with these Terms & Conditions or services provided by Car Genie shall be subject to the jurisdiction of the competent courts in Kolkata, West Bengal.
                        </p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>12.</span> Contact Us </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} >For questions, complaints or service-related concerns, please contact:</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>BM Enterprises</b> <br/>
                            <b>Brand:</b> Car Genie
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Email:</b> <a href="mailto: care@cargenie.co.in "> care@cargenie.co.in </a>
                        </p>
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Phone:</b> <a href="tel: +917003900368"> +91-7003900368  </a>
                        </p>
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Address:</b> <address>1, RIC Bazar, Dunlop,
                                Bonhooghly Government Colony,
                                Kolkata, Baranagar
                                West Bengal 700108
                            </address>
                        </p>
                        

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Car Genie is a brand operated by BM Enterprises.
                        </p>


                    </article>
                </div>
            </section>

        </>
    )
}

export default TermsCondition